import { z } from "zod";

import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";

export const depositFormSchema = z.object({
  amount: z
    .number({ error: () => getTranslation(Resources.Validation.Required) })
    .positive({
      error: () => getTranslation(Resources.Validation.Number.MoreThen),
    }),
  description: z.string().optional(),
});

export type DepositFormData = z.infer<typeof depositFormSchema>;
